import { Link } from "wouter";
import { useLegalDocuments } from "../legal/useLegalDocuments";
import styles from "./Footer.module.css";

/**
 * Diskret afsender-linje på alle flader (trin 9, fase 3d) — branding,
 * ikke reklame. moerk-varianten bruges på essen (/stemple når man er inde).
 */
export function Footer({ variant = "lys" }: { variant?: "lys" | "moerk" }) {
  const { bundle } = useLegalDocuments();

  return (
    <footer
      className={`${styles.footer} ${variant === "moerk" ? styles.moerk ?? "" : ""}`}
    >
      <span>
        Bygget af{" "}
        <a
          href="https://appsmeden.dk"
          target="_blank"
          rel="noopener noreferrer"
        >
          AppSmeden
        </a>{" "}
        — skræddersyede driftssystemer
      </span>
      <span className={styles.legal}>
        <Link href="/jura/privatlivspolitik">Privatlivspolitik</Link>
        <span aria-hidden="true">·</span>
        <Link href="/jura/databehandleraftale">Databehandleraftale</Link>
        {bundle !== null && (
          <span className={styles.version}>
            {bundle.status === "draft" ? "Vilkår i juridisk kladde" : "Gældende vilkår"}
            {" · version "}{bundle.version}
          </span>
        )}
      </span>
    </footer>
  );
}
